<template>
  <div>
    <div v-if="submit_loader"
         style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255, 255, 255, 0.31)">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>

      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <!--            <v-form-->
            <!--                id="create_news"-->
            <!--                @submit.prevent="validateBeforeSubmit('createNews')"-->
            <!--                data-vv-scope="createNews"-->
            <!--                ref="news_form"-->
            <!--                v-model="valid"-->
            <!--            >-->
            <v-card-text>
              <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                <v-layout row wrap>
                  <v-flex xs12 md12 lg12 sm12>
                    <v-expansion-panel class="mb-4" v-model="expandedPanels" @click.native="handleExpansionPanelToggle">
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div>Suggestions</div>
                        </template>
                        <div v-if="isLoadingPanel">
                          <v-progress-linear height="3" :indeterminate="true"
                          ></v-progress-linear>
                        </div>
                        <div v-else>
                          <v-layout row wrap>
                            <v-flex xs12 md12 lg12 style="margin: 0px 10px 0px 10px; height:310px; max-height: 450px;
                          border-radius: 10px; display: flex;" class="scroll-container">
                              <v-item-group>
                                <div style="display: flex;">
                                  <v-item v-for="n in news_suggestions"
                                          :key="n.id" :value="n">
                                    <div class="gallery" style="height: 300px; max-height: 450px; display: flex;
                                      margin-right: 10px; width: 250px;
                                      background-color:#F8F8F8; flex-direction: column;align-content: center;justify-content: center;align-items: center;">
                                      <img
                                          :src="n.image_url"
                                          alt="Commute news" width="230" height="150" style="max-height: 350px;">
                                      <div class="desc">{{ n.title }}</div>
                                      <div>
                                        <v-btn color="primary" type="submit" @click="autoCreateNew(n.link)">
                                          Generate News
                                        </v-btn>
                                      </div>
                                    </div>
                                  </v-item>
                                </div>
                              </v-item-group>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>

                  <v-flex xs12 md6 lg4>
                    <label>Commute Medium</label>
                    <v-autocomplete
                        :items="medium_types"
                        name="Commute Medium"
                        label="Select medium"
                        v-model="news_object.type"
                        return-object
                        item-text="name"
                        @change="resetInput"
                        item-value="id"
                        v-validate="'required'"
                        solo flat
                        :error-messages="errors.collect('createNews.Commute Medium')"
                    >
                    </v-autocomplete>
                  </v-flex>

                  <v-flex xs12 md6 lg4>
                    <label>City:</label>
                    <v-autocomplete
                        :items="cityList"
                        name="CityName"
                        label="Select City"
                        v-model="news_object.city_id"
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        :error-messages="errors.collect('createNews.CityName')"
                        solo flat>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>

                <v-layout row wrap style="display: flex; align-items: center;">
                  <v-flex xs12 sm12 md6 lg5>
                    <label>Source URL </label>
                    <v-text-field
                        name="Source URL"
                        v-model="news_object.source_url"
                        label="Source URL"
                        solo flat
                        clearable
                        v-validate="'required'"
                        :error-message="errors.collect('createNews.Source URL')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg3 style="margin-top: -11px;">
                    <v-btn color="primary" type="submit" @click="autoCreateNew(news_object.source_url)"
                           :disabled="((news_object.source_url == '' || news_object.source_url == null) ||
                             ((news_object.title != '' && news_object.title != null) ||
                             (news_object.description != '' && news_object.description != null)))">Auto
                      Create News
                    </v-btn>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 sm12 md6 lg8>
                    <label>Title </label>
                    <v-text-field
                        name="Title"
                        v-model="news_object.title"
                        label="Title"
                        v-validate="'required'"
                        solo flat
                        :error-messages="errors.collect('createNews.Title')"
                        clearable
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 sm12 md6 lg8>
                    <label>Description: </label>
                    <v-textarea
                        name="Description"
                        v-model="news_object.description"
                        rows="2"
                        v-validate="'required'"
                        solo flat
                        :error-messages="errors.collect('createNews.Description')"
                        clearable
                    >
                    </v-textarea>
                  </v-flex>
                </v-layout>
                <!--                <v-layout row wrap>-->
                <!--                  <v-flex xs12 md6 lg8>-->
                <!--                    <label>Source Name </label>-->
                <!--                    <v-text-field-->
                <!--                        name="Source URL"-->
                <!--                        v-model="news_object.source_name"-->
                <!--                        label="Source Name"-->
                <!--                        solo flat-->
                <!--                        clearable-->
                <!--                    ></v-text-field>-->
                <!--                    <label>Source Name</label>-->
                <!--                    {{ this.news_object.source_name }}-->
                <!--                    <v-combobox-->
                <!--                        :items="news_sources"-->
                <!--                        name="Source"-->
                <!--                        label="Select Source"-->
                <!--                        v-model="news_object.source_name"-->
                <!--                        item-text="name"-->
                <!--                        item-value="name"-->
                <!--                        solo flat-->
                <!--                        :return-object="false">-->
                <!--                    </v-combobox>-->
                <!--                  </v-flex>-->
                <!--                </v-layout>-->

                <!--                <v-layout row wrap>-->
                <!--                  <v-flex xs12 md6 lg8>-->
                <!--                    <label>Image URL </label></br>-->
                <!--                     &lt;!&ndash; <v-text-field-->
                <!--                        name="Source URL"-->
                <!--                        v-model="news_object.image_url"-->
                <!--                        label="Image URL"-->
                <!--                        solo flat-->
                <!--                        clearable-->
                <!--                    ></v-text-field> &ndash;&gt;-->
                <!--                    <input type="file"  name="previewImage" accept="*/*" @change=uploadImage v-validate="'ext:jpg,jpeg,png'" solo flat /><br>-->
                <!--                        <span style="font-size: 11px;">(Allowed file types: JPG,JPEG,PNG)</span>-->
                <!--                        <div class="red&#45;&#45;text pt-3" v-if="errors.collect('news_object.previewImage').length">-->
                <!--                     {{ errors.collect('news_object.previewImage')[0] }}-->

                <!--                    </div>-->
                <!--                  </v-flex>-->
                <!--                </v-layout>-->

                <v-layout row wrap>
                  <v-flex xs12 md8 lg8 style="display: flex; flex-wrap: wrap; padding-bottom: 19px !important;">
                    <v-flex xs12 sm6 md6 lg5 style="padding-bottom: 15px !important;">
                      <label>Upload Image</label>
                      <input type="file" name="image_path" id="image_path" class="form-control flatpickerCSS2"
                             accept="*/*" @change=uploadImage v-validate="'ext:jpg,jpeg,png'"/><br>
                      <span style="font-size: 11px;">(Allowed file types: jpg,jpeg,png)</span>
                      <div class="red--text pt-3" v-if="errors.collect('createNews.image_path').length">
                        {{ errors.collect('createNews.image_path')[0] }}
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg3 class="ImageDisplay"
                            v-if="news_object.previewImage !==''"
                            style="flex-wrap: wrap; flex-direction: column; align-items:center; justify-content: space-around; align-content: space-around;">
                      <v-flex xs12 sm12 md12 lg12
                              style="height: auto; width: auto; align-content: center;">
                        <div v-if="news_object.previewImage" class="mt-3">
                          <img :src="news_object.previewImage" class="figure-img img-fluid rounded"
                               style="max-height:100px;">
                        </div>
                      </v-flex>

                      <v-flex xs12 sm12 md12 lg12>
                        <v-btn icon @click="clearImage()">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-flex>
                  </v-flex>
                </v-layout>


                <v-layout row wrap>
                  <v-flex xs12 md12 lg8 style="display: flex;">
                    <v-flex xs12 md4 lg4>
                      <v-checkbox
                          v-model="news_object.is_scheduled"
                          label="Is Scheduled"
                      ></v-checkbox>
                    </v-flex>

                    <v-flex xs12 md8 lg8 v-if="news_object.is_scheduled == 1">
                      <label>Scheduled At: </label>
                      <div style="padding-bottom: 23px !important;">
                        <flat-pickr
                            class="flatpickerCSS2"
                            label="Scheduled At"
                            v-model="news_object.scheduled_at"
                            :config="config"
                            placeholder="Schedule Date & Time" v-validate="'required'"
                            :error-messages="errors.collect('createNews.Scheduled At')"
                            name="Scheduled At"/>
                      </div>
                    </v-flex>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 md6 lg8>
                    <label>Body: </label>
                    <!--                      <vue-editor-->
                    <!--                          name="news Body"-->
                    <!--                          v-model="news_object.body"-->
                    <!--                          label="news Body"-->
                    <!--                          solo flat-->
                    <!--                      ></vue-editor>-->
                    <quill-editor ref="myQuillEditor"
                                  name="News_Body"
                                  :value="news_object.body"
                                  :options="quillOptions"
                                  label="News Body"
                                  solo flat @input="updateBody"/>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" small :disabled="news_object.type =='' || news_object.title == ''||
                news_object.description == '' || (news_object.is_scheduled == 1 && news_object.scheduled_at == '')"
                     @click="createNews()" type="submit">Create
              </v-btn>
              <v-btn flat small to="/news">Cancel</v-btn>
            </v-card-actions>
            <!--            </v-form>-->
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
          :color="snackBar.color"
          :top="snackBar.top"
          :bottom="snackBar.bottom"
          :left="snackBar.left"
          :right="snackBar.right"
          v-model="snackBar.display"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.display = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
// import {VueEditor, Quill} from "vue2-editor";
import 'quill/dist/quill.snow.css';
import {quillEditor} from 'vue-quill-editor';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moment from "moment";

export default {
  created() {
  },
  computed: {
    // workspaceRequestCode:function(){
    //  return this.news_object.office_id.name + '/'+ this.news_object.tower_id.name + '/' + this.news_object.wing_id.name +'/'+this.news_object.type+'/'+this.news_object.number;
    // }
  },

  components: {
    // VueEditor,
    flatPickr,
    quillEditor
  },
  watch: {
    "news_object.source_url": {
      handler(val) {
        if (val == '' || val == null) {
          this.news_object.source_name = "";
        }
        if (this.news_object.source_url != '') {
          const url = new URL(val);
          this.news_object.source_name = url.hostname.replace(/^www\./i, ' ');
        }

        // this.news_object.source_name = url1.replace(/\b\w/g, (match) => match.toUpperCase());
      }
    },
    "news_object.title": {
      handler(val) {
        if (val == '' || val == null) {
          this.news_object.title = "";
        }
      }
    },
    "news_object.description": {
      handler(val) {
        if (val == '' || val == null) {
          this.news_object.description = "";
        }
      }
    },
    "news_object.is_scheduled": function (val) {
      if (val == false) {
        this.news_object.scheduled_at = "";
      }
    },
    "news_object.body": function (val) {
      if (val == '' || val != null) {

        setInterval(this.handleTextChange, 1000);
      }
    }
  },
  methods: {
    resetInput() {
      this.news_object.title = "";
      this.news_object.local_line = "";
      this.news_object.description = "";
      this.news_object.is_scheduled = 0;
      this.news_object.scheduled_at = "";
      return;
    },
    // create_news: function() {
    //   this.submit_loader =true;
    //   this.news_object.source_name =this.news_object.source_name.name
    //   let new_news  = Object.assign({},this.news_object);
    //   axios.post(`${process.env.VUE_APP_API_URL}/api/v1/add-news`, new_news,{headers:this.$headers})
    //   .then((response)=>{
    //     if(response.data.status == 1)
    //     {
    //       this.submit_loader =false;
    //     }
    //
    //      }).catch((error)=>{
    //           console.log(error);
    //         }).finally(()=>{
    //           this.submit_loader =  false;
    //         });
    // },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        this.news_object.previewImage = e.target.result;
        // console.log(this.previewImage);
      };
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    createNews: function () {
      this.submit_loader = true;
      // this.news_object.source_name =this.news_object.source_name
      let new_news = Object.assign({}, this.news_object);
      // new_news.title = this.news_object.title;
      // new_news.description = this.news_object.description;
      // new_news.pin_till = this.news_object.date;
      // new_news.type = this.news_object.type.id;
      // new_news.local_line = this.news_object.local_line;
      // new_news.body = this.news_object.body;
      // new_news.is_notify = this.news_object.is_notify;
      // new_news.ext_link = this.news_object.ext_link;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/add-news`, new_news, {headers: this.$headers}).then((response) => {

        if (response.data.status == 1) {
          var news = response.data.news;
          this.$router.push('/news/' + news.id);
          this.submit_loader = false;
        } else {
          this.snackBar.message = response.data.message;
          this.snackBar.display = true;
        }

      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.submit_loader = false;
      });

    },
    getTypeList: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/commute-mediums`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.medium_types = response.data.types;
            }

          })
    },
    getSources: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/news-sources`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.news_sources = response.data.list;
            }

          })
    },
    clearImage() {
      this.news_object.previewImage = null;
      $('#image_path').val('');
      const index = this.errors.items.findIndex(item => item.field == 'image_path');
      if (index !== -1) {
        this.errors.items.splice(index, 1);
      }
    },
    autoCreateNew(source_url) {
      this.startLoading();
      this.news_object.source_url = source_url;
      axios.get(`https://hook.us1.make.com/ckdczp4u3uq9k87pf6j1u7eqj4j7uixx?url=` + source_url,
          {'Content-Type': 'application/x-www-form-urlencoded'})
          .then((response) => {
            if (response) {
              this.stopLoading();
              this.news_object.title = JSON.parse(response.data.title_desc).title;
              this.news_object.description = JSON.parse(response.data.title_desc).description;
              this.news_object.body = JSON.parse(response.data.body).summary;
            }
          }).catch((error) => {
        this.stopLoading();
        this.snackBar.message = "Something went wrong.";
        this.snackBar.display = true;
        console.log(error);
      })
    },
    getNewsSuggestions() {
      this.isLoadingPanel = true;
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/suggestion-links`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.isLoadingPanel = false;
              this.news_suggestions = response.data.data;
            }
          }).catch((error) => {
        this.isLoadingPanel = false;
      });
    },
    handleExpansionPanelToggle() {
      if (this.expandedPanels != null || this.expandedPanels == 0) {
        this.getNewsSuggestions();
      }
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    handleTextChange() {
      if (this.news_object.body != null || this.news_object.body == '') {
        const containsImages = this.news_object.body.includes('<img');
        if (containsImages) {
          const imageData = this.news_object.body.match(/<img[^>]+src="([^">]+)"/g);

          imageData.forEach((element) => {
            const srcMatch = element.match(/src="([^"]+)"/);

            let Image_data = srcMatch[1];
            if (Image_data.startsWith('data:image/png;base64,') ||
                Image_data.startsWith('data:image/jpg;base64,') ||
                Image_data.startsWith("data:image/jpeg;base64,")) {
              axios.post(`${process.env.VUE_APP_API_URL}/api/v1/add-image-to-azure`, {Image_data})
                  .then(response => {
                    if (response.data.status == 1) {

                      this.image_flag = 1;
                      this.azure_image_path = response.data.data;

                      const new_UrL = process.env.VUE_APP_AZURE_STORAGE_URL +
                          process.env.VUE_APP_AZURE_STORAGE_CONTAINER + '/' + this.azure_image_path;

                      const escapedOldSrc = this.escapeRegExp(srcMatch[1]);//RegExp.escape(srcMatch[1]);
                      const regex = new RegExp(`<img src="${escapedOldSrc}"`, 'g');
                      this.news_object.body =
                          this.news_object.body.replace(regex, `<img src="${new_UrL}"`);

                      // var htmlString = this.news_object.body;
                      //
                      // var tempElement = document.createElement('div');
                      // tempElement.innerHTML = htmlString;
                      //
                      // var img = tempElement.querySelector('img');
                      // if (img) {
                      //   img.setAttribute('style','max-width: 100%; height: auto;');
                      // }
                      // var CSS1 = "max-width: 100%; height: auto;";
                      //
                      // const regex1 = new RegExp(`<img[^>]+style="${CSS1}"`, 'g');
                      // this.news_object.body =
                      //     this.news_object.body.replace(regex1, `<img style="max-width: 100%; height: auto;"`);

                      // this.updateBodyTag(new_UrL);

                    }
                  })
            }
          });
        }
      }
    },
    updateBody(value) {
      this.$set(this.news_object, 'body', value);
    },
    getCityList() {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id' : 0, 'name':"ALL"})
            }
          });
    }
    // updateBodyTag(value) {
    //   this.news_object.body = this.news_object.body.replace(/<img[^>]+src="([^">]+)"/g,
    //       `<img src="${value}"`);
    // },


    // getLinkUrl(val) {
    //   this.suggested_news_link_url = "";
    //   this.suggested_news_link_url = val;
    //   this.news_object.source_url = val;
    //   this.newsSuggestionDialog = false;
    //
    // }

  },
  data: () => {
    return {
      display_search: true,
      news_object: {
        title: "",
        type: "",
        description: "",
        body: "",
        source_name: "",
        source_url: "",
        is_notify: false,
        image_url: "",
        previewImage: "",
        is_pinned: false,
        is_scheduled: 0,
        scheduled_at: '',
        new_body: ''
      },
      is_populate: false,
      submit_loader: false,
      valid: false,
      title_content: '',
      description_content: '',
      floor_list: [],
      medium_types: [],
      train_codes: [],
      local_lines: [],
      tower_list: [],
      wing_list: [],
      auth_user: {
        roles: [{}]
      },
      workspaceRequestCode: "",
      snackBar: {
        display: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false
      },
      news_sources: [],
      newsSuggestionDialog: false,
      suggested_news_link_url: '',
      news_suggestions: [],
      isLoadingPanel: false,
      expandedPanels: [],
      config: {
        enableTime: true,
        altInput: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: false,
        minDate: moment().format('YYYY-MM-DD'),
        maxDate: moment().add(45, 'days').format('YYYY-MM-DD')
      },
      quillOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['link'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['blockquote', 'code-block'],
            [{'header': 1}, {'header': 2}],
            [{'script': 'sub'}, {'script': 'super'}],
            [{'indent': '-1'}, {'indent': '+1'}],
            [{'direction': 'rtl'}],
            [{'size': ['small', false, 'large', 'huge']}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            ['clean'],
            ['image']
          ]
        },
        theme: 'snow'
      },
      azure_image_path: '',
      cityList: [],
    }
  },

  mounted() {
    this.getCityList();
    this.getTypeList();
    // this.getNewsSuggestions();
    // this.getSources();
  },

};
</script>
<!--<style>-->
<!--div.scroll-container {-->
<!--  overflow: auto;-->
<!--  white-space: nowrap;-->
<!--  padding: 10px;-->
<!--}-->

<!--div.scroll-container img {-->
<!--  padding: 0px 10px 0px 10px;-->
<!--}-->

<!--div.gallery {-->
<!--  border: 1px solid #ccc;-->
<!--}-->

<!--div.gallery:hover {-->
<!--  border: 1px solid #777;-->
<!--}-->

<!--div.gallery img {-->
<!--  width: 100%;-->
<!--  height: auto;-->
<!--}-->

<!--div.desc {-->
<!--  padding: 15px;-->
<!--  text-align: center;-->
<!--  white-space: pre-wrap;-->
<!--}-->

<!--* {-->
<!--  box-sizing: border-box;-->
<!--}-->
<!--</style>-->
